import styled from 'styled-components';

export const Wrapper = styled.div`
  height: fit-content;
  display: flex;
  justify-content: center;
`;

export const MainWrapper = styled.div`
  padding-top: 32px;
  height: fit-content;
`;
